import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "cabrioletFilled"
const CabrioletFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.75 15C7.786 15 8.625 15.84 8.625 16.875S7.785 18.75 6.75 18.75 4.875 17.91 4.875 16.875 5.715 15 6.75 15M17.625 15C18.66 15 19.5 15.84 19.5 16.875S18.66 18.75 17.625 18.75 15.75 17.91 15.75 16.875 16.59 15 17.625 15" />
          <path d="M12.204 9.239C12.28 8.937 12.584 8.754 12.886 8.829L12.888 8.83H12.893L12.907 8.836 12.962 8.849 13.152 8.902C13.312 8.948 13.533 9.016 13.78 9.102 14.256 9.269 14.889 9.526 15.338 9.862 15.77 10.189 16.182 10.656 16.47 11.017 16.599 11.176 16.708 11.323 16.79 11.438H16.94L17.002 11.452 21.295 12.442C21.891 12.58 22.312 13.111 22.312 13.722V14.062H21.376C21.065 14.063 20.813 14.315 20.813 14.626S21.064 15.188 21.375 15.188H22.313V15.75C22.313 16.475 21.725 17.063 21 17.063H20.242Q20.249 16.97 20.25 16.875C20.25 15.425 19.075 14.25 17.625 14.25S15 15.425 15 16.875Q15.001 16.97 15.008 17.063H9.367Q9.374 16.97 9.375 16.875C9.375 15.425 8.2 14.25 6.75 14.25 5.414 14.25 4.312 15.248 4.147 16.539L2.847 16.387C2.186 16.309 1.687 15.748 1.687 15.083V14.437H2.625C2.935 14.438 3.188 14.187 3.188 13.876 3.188 13.565 2.936 13.313 2.625 13.313H1.688V12.98C1.688 12.364 2.12 11.829 2.725 11.699L7.532 10.668 7.678 10.716 9.563 11.344V10.5C9.563 10.19 9.814 9.938 10.125 9.938 10.435 9.938 10.688 10.189 10.688 10.5V11.438H15.358C15.136 11.184 14.892 10.936 14.661 10.762 14.361 10.536 13.87 10.325 13.408 10.164 13.186 10.086 12.985 10.024 12.84 9.983L12.67 9.935 12.627 9.925 12.616 9.92H12.614C12.312 9.845 12.129 9.54 12.204 9.239" />
        </svg>
      }
    </span>
  )
}
export default CabrioletFilledIcon
